export const GetQuery = () => {
  const search = window.location.search;
  return new URLSearchParams(search);
};
